/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import WarningCard from 'assets/images/rounded_warning.svg';

interface RobotComprasnetWarningProps {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}

const RobotComprasnetWarning = (props: RobotComprasnetWarningProps) => {
  const { setShowModal, showModal } = props;

  const handleClose = () => setShowModal(false);

  return (
    <Modal show={showModal}>
      <div className="col-md-12 text-center">
        <div className="p-5" style={{ width: '455px' }}>
          <img
            className="text-center"
            src={WarningCard}
            alt="Imagem error"
            style={{ width: '120px' }}
          />
          <div className="card-body">
            <h5 className="card-title font-weight-bold mb-0">Aviso!</h5>
            <span className="card-text mt-1 ">
              O Robô de Lance Inteligente só está disponível para licitações da{' '}
              <strong>Lei 10.520</strong>. Em breve, estará disponível para todas as licitações do
              Compras.gov.br.
            </span>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary btn-block "
              onClick={() => handleClose()}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RobotComprasnetWarning;
